import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import { KnowledgeConnections } from "@/components/knowledge/KnowledgeConnections";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { JsonLd } from "@/components/JsonLd";
import { generateCanonicalUrl } from "@/utils/seoHelpers";

const SEOMemorialPage = () => {
  const [language] = useState<'es' | 'en'>('es');
  const canonical = generateCanonicalUrl('/seo-memorial');

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "SEO en Memorial Houston",
    areaServed: {
      "@type": "Place",
      name: "Memorial, Houston, TX"
    },
    provider: { "@id": "https://luisroc.com/#organization" },
    description: "Posicionamiento SEO en Memorial, Houston para negocios locales. Auditoría, SEO local y estrategias que atraen clientes."
  };

  return (
    <>
      <Helmet>
        <html lang={language} />
        <title>SEO Memorial Houston TX | Posicionamiento Local – Luis ROC</title>
        <meta name="description" content="Posicionamiento SEO en Memorial, Houston para negocios locales. Auditoría, SEO local y estrategias que atraen clientes. Reunión inicial gratuita." />
        <meta name="keywords" content="SEO Memorial Houston, posicionamiento web Memorial, SEO local Memorial TX, consultor SEO Houston" />
        <link rel="canonical" href={canonical} />
      </Helmet>

      <JsonLd data={serviceSchema} />

      <div className="min-h-screen bg-background">
        <Header language={language} onLanguageChange={() => {}} />
        <main className="container mx-auto px-4 py-16 text-center">
          <h1 className="text-4xl font-bold mb-6">SEO en Memorial Houston TX</h1>
          <p className="max-w-2xl mx-auto mb-8 text-muted-foreground">
            Mejora tu visibilidad en Memorial con SEO local, contenido optimizado y estrategias pensadas para captar clientes en Houston.
          </p>
          <Button size="lg" onClick={() => (window.location.href = "/diagnostico-seo-gratis")}>Reunión inicial gratuita de 30 minutos</Button>
        </main>
        <KnowledgeConnections path="/seo-memorial" language={language} />

        <Footer language={language} />
      </div>
    </>
  );
};
export default SEOMemorialPage;
